import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

export interface OptionList<T = unknown> {
  icon?: string;
  show: boolean;
  title: string;
  appendTitle?: string;
  description?: string;
  descriptionTemplate?: TemplateRef<unknown>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  route?: string | any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryParams?: Record<string, any>;
  queryParamsHandling?: 'merge' | 'preserve' | '';
  replaceUrl?: boolean;
  imgIcon?: boolean;
  explainTooltip?: string;
  selectedValue?: T;
  disabled?: boolean;
  unreadState?: boolean;
}
@Component({
  selector: 'liberro-option-list',
  standalone: false,
  templateUrl: './liberro-option-list.component.html',
  styleUrl: './liberro-option-list.component.less'
})
export class LiberroOptionListComponent<T = unknown> {
  @Input() public optionList: OptionList<T>[] = [];
  @Input() public displayLastDivider = true;
  @Input() public variant: 'default' | 'simple' = 'default';
  @Input() public fontType: 'default' | 'bold' = 'default';
  @Input() public autoTranslate = true;
  @Input() public relativeIconPath = true;
  @Input() public iconSize = 24;
  @Input() public highligtedValue: T | null = null;
  @Output() public optionSelected = new EventEmitter<T>();

  public selectOption(selectedValue: T | undefined): void {
    if (selectedValue) this.optionSelected.emit(selectedValue);
  }
}
